import { render } from "./SearchPaginationWrapper.vue?vue&type=template&id=120c0040"
import script from "./SearchPaginationWrapper.vue?vue&type=script&lang=js"
export * from "./SearchPaginationWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__